<template>
    <p class="text-secondary small help">
        Need assistance? Reach out to us at
        <a href="mailto:support@affinitylearning.ca?subject=Support Request"> support@affinitylearning.ca</a>.
    </p>
</template>

<script>
export default {
    name: "SupportRequestPrompt",
}
</script>
